import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  adaptorsSectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  accommodationSectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '30px'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row'
  },
  adaptorsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr ',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  accommodationsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr ',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))

export default useStyles
